mutation CreateMentionNotification($contentId: ID!, $mentions: [ContentMention]!) {
  createContentMentionNotificationAction(
    input: { contentId: $contentId, mentions: $mentions }
  ) {
    contentId
    success
    errors {
      message
    }
  }
}
